import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const JobModal = () => {
  const [show, setShow] = useState(true);
  const navigate = useNavigate();

  const handleClose = () => {
    setShow(false);
    navigate("/careers");
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    qualification: "",
    experiance: "",
    aadhaar: "",
    address: "",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted:", formData);
    setShow(false);
    navigate("/career");
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}  size="">
        <Modal.Header closeButton>
          <Modal.Title>User Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
           <Row>
           <Form.Group className="col">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="col">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                onChange={handleChange}
                required
              />
            </Form.Group>
           </Row>

           <Row>
           <Form.Group className="col">
              <Form.Label>Mobile No</Form.Label>
              <Form.Control
                type="tel"
                name="mobile"
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="col">
              <Form.Label>Qualification</Form.Label>
              <Form.Control
                type="text"
                name="qualification"
                onChange={handleChange}
                required
              />
            </Form.Group>
</Row>
<Row>
<Form.Group className="col">
              <Form.Label>Experiance</Form.Label>
              <Form.Control
                type="number"
                name="experiance"
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="col">
              <Form.Label>Aadhaar No</Form.Label>
              <Form.Control
                type="text"
                name="aadhaar"
                onChange={handleChange}
                required
              />
            </Form.Group>
</Row>
         

            <Form.Group className="mb-2">
              <Form.Label>Address</Form.Label>
              <Form.Control
                type="text"
                name="address"
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Button variant="success" type="submit" className="mt-3 w-100">
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default JobModal;